module.exports = __webpack_public_path__ + "static/media/insta-7.6ba90e66.png";